import React, { forwardRef } from 'react';

import { useIntl } from 'react-intl';

import { convertToString, IntlMsgShape } from 'helpers/consts';

export type IImageProps = Omit<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >,
  'alt'
> & { alt: string | IntlMsgShape };

const Image = forwardRef<HTMLImageElement, IImageProps>(
  ({ alt, ...props }, ref) => {
    const { formatMessage } = useIntl();

    const altMessage = convertToString(alt, formatMessage);

    return (
      <img data-cy="data-cy-image" alt={altMessage} ref={ref} {...props} />
    );
  },
);

export default Image;
